import React from 'react';
import { timeAgo } from '@/utils/ts/stringUtils';

import RightArrow from '@/components/Icons/icons/RightArrow';

import ratnaImage from '../../../images/discovery/ratna.svg';
import ButtonComponent from '../ButtonComponent/ButtonComponent';

export default function RatnaNotification({ notification, showReviewButton = false, onClickReviewButton = () => {} }) {
  return (
    <div className={`single-notification ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="avatar-div">
        <img src={ratnaImage} alt="ratna" width={36} style={{ marginLeft: -6 }} />
      </div>
      <div className="text-div" style={{ marginLeft: 6 }}>
        <h3 className="title">{notification?.title}</h3>
        <p className="description">{notification?.content?.body}</p>
        {showReviewButton && (
          <div className="mt-2">
            <ButtonComponent
              variant="text-highlight"
              className="p-0"
              onClick={() => {
                onClickReviewButton();
              }}
              rightIcon={<RightArrow color="var(--text-highlight)" />}>
              <span className="text-sm">Review </span>
            </ButtonComponent>
          </div>
        )}
        <p className="timestamp" style={{ paddingTop: 8 }}>
          {timeAgo(notification?.createdAt)}
        </p>
      </div>
    </div>
  );
}
